const MONTH_ABBR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/** `2026-05` → `May 2026`. Falls back to the raw value when malformed. */
export function formatMonthShort(month: string): string {
  const [y, m] = month.split("-");
  const name = MONTH_ABBR[Number(m) - 1];
  return name && y ? `${name} ${y}` : month;
}

/** `2026-05` → `May`, plus the year when it is January or the first column. */
export function formatMonthColumn(month: string, withYear: boolean): string {
  const [y, m] = month.split("-");
  const name = MONTH_ABBR[Number(m) - 1] ?? month;
  return withYear || m === "01" ? `${name} ${(y ?? "").slice(2)}` : name;
}

/** `2026-05-14` → `May 2026`, or "—" for null. */
export function formatDateMonth(date: string | null): string {
  return date === null ? "—" : formatMonthShort(date.slice(0, 7));
}

/** Hours with at most one decimal: 147 → "147", 110.5 → "110.5". */
export function formatHours(hours: number): string {
  return Number.isInteger(hours) ? String(hours) : hours.toFixed(1);
}
